<template>
  <div>
    <ui-icon
      v-if="index !== -1"
      icon="fas fa-star"
      :color="$colors.sunglow"
      @click.stop="switchMenu"
    ></ui-icon>
    <ui-icon
      v-else
      color="inherit"
      @click.stop="switchMenu"
      icon="far fa-star"
    ></ui-icon>
  </div>
</template>

<script setup lang="ts">
import { useColors } from '@/composables';
import { $emitter } from '@/services/emitter';

const props = defineProps<{
  index: number;
  item: {
    id: string;
    tabId?: number;
    url: string;
    drill?: unknown;
  };
  title: string;
}>();

const $colors = useColors();

const switchMenu = () => {
  $emitter.emit('open-dialog', {
    name: 'BookmarkAddDialog',
    data: { index: props.index, item: props.item, title: props.title },
  });
};
</script>
